import { EthAddress } from '@xylabs/sdk-js'
import { PropsWithChildren, useContext, useEffect, useState } from 'react'

import { useEntity, XyoWorldEntity } from '../../Hooks'
import { GeotokensContext } from '../Geotokens'
import Context from './Context'

interface Props {
  address?: EthAddress
  enabled?: boolean
}

const Loader: React.FC<PropsWithChildren<Props>> = (props) => {
  const { geotokens } = useContext(GeotokensContext)
  const address = props.address
  const entityToUse = useEntity(address, geotokens)
  const [entity, setEntity] = useState<XyoWorldEntity>()

  useEffect(() => {
    setEntity(undefined)
    if (entityToUse) {
      setEntity(entityToUse)
    }
  }, [entityToUse])

  return <Context.Provider value={entity}>{props.children}</Context.Provider>
}

export default Loader
